export default "__VITE_ASSET__DGxNd5lY__"